import { authenticate } from '@kiper/fns';
import * as manager from './eventTriggerSetting.manager';

export const eventTriggerSettings = authenticate(({ args, context }) =>
  manager.getList({ filters: args.filters, ...context }),
);

export const eventTriggerSetting = authenticate(({ args, context }) =>
  manager.get({ id: args.id, ...context }),
);
